export const METRIC_LABELS: Record<string, string> = {
    market_opportunity: '市场机会指数',
    entry_barrier: '进入壁垒指数',
    traffic_quality: '流量质量评分',
    ad_priority: '广告优先级评分',
};

export const COMPONENT_LABELS: Record<string, string> = {
    market_control: '市场控制度',
    replacement_rate: '可替换率',
    brand_concentration: '品牌集中度',
    conversion_advantage: '转化优势',
    brand_diversity: '品牌多样性',
    concentration: '垄断集中度',
    stability: '市场稳定性',
    diversity: '品牌多样性',
    fluidity: '市场流动性',
    efficiency: '流量效率',
    rank_score: '排名得分',
    opportunity_score: '机会得分',
    quality_score: '质量得分',
    trend_factor: '趋势因子',
};
